import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "button"]

  connect() {
    this.contentTargets.forEach((content) => {
      content.classList.add("hidden")
    })

    this.buttonTargets.forEach((button, index) => {
      button.setAttribute('aria-expanded', 'false')
      this.iconTargets[index].classList.remove('rotate-180')
    })
  }

  toggle(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.contentTargets[index].classList.toggle("hidden")
    this.iconTargets[index].classList.toggle("rotate-180")

    const button = event.currentTarget
    const expanded = button.getAttribute("aria-expanded") === "true"
    button.setAttribute("aria-expanded", !expanded)
  }
}
